<template>
  <NuxtLayout name="catalog">

    <div class="page-info" :class="specialCssClass">
      <div class="page-container">
        <MoleculesGlobalBreadcrumb :segments="props.breadcrumbSegments" :show-all-segments="true" />
      </div>

      <div class="page-info__heading">
        <div class="page-info__wrapper">
          <h1>{{ entity.page.header }}</h1>
        </div>
      </div>

      <div class="page-info__wrapper">
        <div :class="{ 'page-info__content': !specialCssClass }">
          <MoleculesBlocksInfoPageElement :element="mappedContent[0]" />
        </div>

        <!-- lexicon navigation -->

        <div v-if="entity.type === appConfig.infoPageTypes.lexicon && (previousLexiconInfopage || nextLexiconInfopage)" class="page-info__lexicon-navigation">
          <AtomsTextLink v-if="previousLexiconInfopage" :href="previousLexiconInfopage.url" class="page-info__lexicon-navigation__link">
            <AtomsImagesIcon icon="arrow-left" size="lg" />
            <div class="underline">
              <div class="page-info__lexicon-navigation__label">{{ $t('Předchozí pojem') }}</div>
              <div class="text-neutral-400">{{ previousLexiconInfopage.title }}</div>
            </div>
          </AtomsTextLink>
          <div v-if="previousLexiconInfopage && nextLexiconInfopage" class="page-info__lexicon-navigation__separator">
          </div>
          <AtomsTextLink v-if="nextLexiconInfopage" :href="nextLexiconInfopage.url" class="page-info__lexicon-navigation__link">
            <div class="underline">
              <div class="page-info__lexicon-navigation__label">{{ $t('Další pojem') }}</div>
              <div class="text-neutral-400">{{ nextLexiconInfopage.title }}</div>
            </div>
            <AtomsImagesIcon icon="arrow-right" size="lg" />
          </AtomsTextLink>
        </div>
      </div>

      <div class="page-container">

        <!-- recently viewed items -->

        <LazyTemplatesRecentlyViewedItems />

        <!-- usp -->

        <OrganismsBlocksUsps class="mb-4 desktop:mb-6" item-class="!bg-neutral-100 desktop:aspect-[7/3]" />

      </div>

    </div>
  </NuxtLayout>
</template>
<script setup>

const props = defineProps({
  breadcrumbSegments: Array,
  articleAnalyticsData: Object
});

const appConfig = useAppConfig();
const entity = useEntity();
const locale = useLocale().getLocale();
const content = useContent();
const page = usePage().value.page;

const mappedContent = content.transformHtmlContent(entity.content, page.id);

let specialCssClass = '';

if (page.id in appConfig.specialPageCssClasses) {
  specialCssClass = appConfig.specialPageCssClasses[page.id];
}

const removeTrailingLines = () => {
  var items = document.querySelectorAll('.information-center .sections ul > *');
  for (var i = 0; i < items.length; i++) {
    var current = items[i];
    var next = items[i + 1];
    if (next && current.getBoundingClientRect().top !== next.getBoundingClientRect().top) {
      current.classList.add('end-of-line');
    } else {
      current.classList.remove('end-of-line');
    }
  }
};

//#region lexicon

let previousLexiconInfopage, nextLexiconInfopage;

if (entity.type === appConfig.infoPageTypes.lexicon) {
  const lexiconInfopages = (await useApiFetch(`/api/lexicon?currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).infoPageList.infoPages.items;

  const sortedLexiconInfoPages = lexiconInfopages.map(item => {
    return {
      title: item.page.title,
      url: item.page.url
    }
  }).sort((a, b) => a.title.localeCompare(b.title));

  const indexOfCurrent = sortedLexiconInfoPages.findIndex(item => item.url === usePage().value.page.url);

  if (indexOfCurrent > 0) {
    previousLexiconInfopage = sortedLexiconInfoPages[indexOfCurrent - 1];
  }

  if (indexOfCurrent < sortedLexiconInfoPages.length - 1) {
    nextLexiconInfopage = sortedLexiconInfoPages[indexOfCurrent + 1];
  }

  if (props.articleAnalyticsData) {
    useBaseAnalytics().pushEvent('article_view', props.articleAnalyticsData);
  }
}

//#endregion

onMounted(() => {
  removeTrailingLines();
  window.addEventListener('resize', removeTrailingLines);
});

onUnmounted(() => {
  window.removeEventListener('resize', removeTrailingLines);
});

</script>
<style lang="postcss"></style>